
export const handleAdminStaffSearch = (e: any, setSearchQuery: Function, navigate: Function) => {
    if (e?.target?.value?.length > 2) {
        setSearchQuery(e?.target?.value)
        navigate(`/admin/user-settings/1`);
    }
    else {
        setSearchQuery('')
    }
}